import types from "../http_common";
import bearerToken from './getApiToken';

// SMS Template Management API calls
const saveTemplate = async (template, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  return await api.post('/comms/sms/templates', template);
};

const getTemplates = async (instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  return await api.get('/comms/sms/templates');
};

const getTemplate = async (templateId, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  return await api.get(`/comms/sms/templates/${templateId}`);
};

const updateTemplate = async (templateId, template, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  return await api.put(`/comms/sms/templates/${templateId}`, template);
};

const deleteTemplate = async (templateId, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  return await api.delete(`/comms/sms/templates/${templateId}`);
};

// SMS Conversation Management
const startConversation = async (phoneNumber, templateId, contextData, instance, options = {}) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  return await api.post('/comms/sms/conversations/start', {
    phoneNumber,
    templateId,
    contextData,
    firstMessageOverride: options.firstMessageOverride || null
  });
};

const processResponse = async (customString, message, from, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  return await api.post('/comms/sms/incoming', {
    custom_string: customString,
    message,
    from
  });
};

const getConversation = async (conversationId, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  return await api.get(`/comms/sms/conversations/${conversationId}`);
};

const getConversations = async (filters, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  
  const queryParams = new URLSearchParams();
  if (filters) {
    Object.keys(filters).forEach(key => {
      if (filters[key] !== null && filters[key] !== undefined) {
        queryParams.append(key, filters[key]);
      }
    });
  }
  
  return await api.get(`/comms/sms/conversations?${queryParams.toString()}`);
};

const getConversationHistory = async (conversationId, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  return await api.get(`/comms/sms/conversations/${conversationId}`);
};

// SMS Sending (Enhanced from existing karmaApi)
const sendSMS = async (phoneNumber, message, customString, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  
  const params = new URLSearchParams({
    number: phoneNumber,
    message: message
  });
  
  if (customString) {
    params.append('customString', customString);
  }
  
  return await api.get(`/comms/sendSMS?${params.toString()}`);
};

const sendSMSWithTemplate = async (phoneNumber, templateId, contactId, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  return await api.post('/sms/send-template', {
    phoneNumber,
    templateId,
    contactId
  });
};

// Analytics and Reporting
const getTemplateAnalytics = async (templateId, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  return await api.get(`/sms/analytics/templates/${templateId}`);
};

const getConversationAnalytics = async (filters, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  
  const queryParams = new URLSearchParams();
  if (filters) {
    Object.keys(filters).forEach(key => {
      if (filters[key] !== null && filters[key] !== undefined) {
        queryParams.append(key, filters[key]);
      }
    });
  }
  
  return await api.get(`/sms/analytics/conversations?${queryParams.toString()}`);
};

// Webhook for incoming SMS responses
const handleIncomingSMS = async (webhookData, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  return await api.post('/sms/webhook/incoming', webhookData);
};

// Test conversation flow
const testTemplate = async (templateId, testScenarios, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  return await api.post(`/sms/templates/${templateId}/test`, testScenarios);
};

// Delivery Status Tracking
const getDeliveryStats = async (filters, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  
  const queryParams = new URLSearchParams();
  if (filters) {
    Object.keys(filters).forEach(key => {
      if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
        queryParams.append(key, filters[key]);
      }
    });
  }
  
  return await api.get(`/comms/sms/delivery/stats?${queryParams.toString()}`);
};

const getFailedDeliveries = async (page = 1, limit = 50, filters = {}, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString()
  });
  
  if (filters) {
    Object.keys(filters).forEach(key => {
      if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
        queryParams.append(key, filters[key]);
      }
    });
  }
  
  return await api.get(`/comms/sms/delivery/failed?${queryParams.toString()}`);
};

const getConversationWithDelivery = async (conversationId, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  return await api.get(`/comms/sms/conversations/${conversationId}/delivery`);
};

const sendManualConversationReply = async (conversationId, message, instance, options = {}) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  return await api.post(`/comms/sms/conversations/${conversationId}/manual-send`, {
    message,
    // Default is to hand the conversation to a human and stop the automated
    // flow. Pass true only when the flow should carry on regardless.
    keepFlowRunning: options.keepFlowRunning === true
  });
};

const updateConversationStatus = async (conversationId, status, instance) => {
  var api = types.json();
  const item = await bearerToken(instance);
  api.defaults.headers.common.Authorization = 'Bearer ' + item;
  return await api.put(`/comms/sms/conversations/${conversationId}/status`, { status });
};

const SMSApiService = {
  // Template Management
  updateConversationStatus,
  saveTemplate,
  getTemplates,
  getTemplate,
  updateTemplate,
  deleteTemplate,
  
  // Conversation Management
  startConversation,
  processResponse,
  getConversation,
  getConversations,
  getConversationHistory,
  
  // SMS Sending
  sendSMS,
  sendSMSWithTemplate,
  
  // Analytics
  getTemplateAnalytics,
  getConversationAnalytics,
  
  // Delivery Tracking
  getDeliveryStats,
  getFailedDeliveries,
  getConversationWithDelivery,
  sendManualConversationReply,
  
  // Webhooks
  handleIncomingSMS,
  
  // Testing
  testTemplate
};

export default SMSApiService;